<a id="genericListLink-link-{{ linkTitle | camelCase }}-{{ testingId | camelCase }}" (click)="handleClick($event)" uzDebounceClick>
  {{ linkTitle }}
</a>
